import BigLogo from "@publicPortal/components/bigLogo/BigLogo";
import ResultBoard from "@publicPortal/components/resultBoard/ResultBoard";
import { ConsulteeService } from "@publicPortal/services/ConsulteeService";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { VerifyConsulteeResult } from "@shared/mirage/core/contracts/User";
import React, { useEffect, useState } from "react";
import LoginConsultee from "../loginConsultee/LoginConsultee";

const VerifyConsultee = () => {
    const initialState = {
        message: "",
        error: "",
    } as IConsulteeProcess;
    const consulteeService = new ConsulteeService();
    const consulteeTokenString = localStorage.getItem("verifyConsultee.token");
    const urlParams = new URL(window.location.href).searchParams;
    const token = urlParams.get("t");
    const pp = new PublicPortalRoutingService();
    const [isLoading, setIsLoading] = useState(true);
    const [consulteeToken, setConsulteeToken] = useState<VerifyConsulteeResult>({} as VerifyConsulteeResult);
    const [consulteeVerification, setConsulteeVerification] = useState<IConsulteeProcess>(initialState);

    useEffect(() => {
        verifyConsultee();
    }, []);

    if (isLoading || consulteeVerification.error) {
        return verifyContent();
    }
    return loginContent();

    function verifyContent() {
        return (
            <>
                <BigLogo />
                <ResultBoard
                    headerText={"Verify Consultee"}
                    loading={isLoading}
                    success={!consulteeVerification.error}
                    message={consulteeVerification.message}
                    buttonLabel="Go home"
                    buttonNavTo={pp.Root}
                />
            </>
        );
    }

    function loginContent() {
        return <LoginConsultee paId={consulteeToken.paId} consulteeEmail={consulteeToken.consulteeEmail} consulteePassword={consulteeToken.consulteePassword} />;
    }

    async function verifyConsultee() {
        if (!token) {
            updateConsulteeVerification("Token is required to verify consultee", "No token found");
            setIsLoading(false);
            return;
        }
        const verificationResult = await consulteeService.verifyConsultee({ token });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const tokenDataToStore: Partial<VerifyConsulteeResult> = (({ consulteeEmail, consulteePassword, ...obj }) => obj)(verificationResult);
        if (verificationResult && !verificationResult.error) {
            if (consulteeTokenString) {
                localStorage.removeItem("verifyConsultee.token");
            }
            setConsulteeToken(verificationResult);
            localStorage.setItem("verifyConsultee.token", JSON.stringify(tokenDataToStore));
        } else {
            updateConsulteeVerification(verificationResult?.error || "Something went wrong", verificationResult?.error || "error");
        }
        setIsLoading(false);
    }

    function updateConsulteeVerification(message: string, error?: string) {
        setConsulteeVerification(() => {
            return {
                message: message,
                error: error,
            };
        });
    }
};

export interface IConsulteeProcess {
    message: string;
    error?: string;
}

export default VerifyConsultee;
